import { t } from 'i18next';

export const userTabs = {
  user: {
    key: 'user',
    label: t('users.user'),
  },
  rolesPermissions: {
    key: 'roles-permissions',
    label: t('users.roles.rolesPermissions'),
  },
  skills: {
    key: 'skills',
    label: t('users.skills.skills'),
  },
  organisations: {
    key: 'organisation',
    label: t('common.contact.organisation'),
  },
};
